import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/Tooltip/Tooltip';
import { cn } from '@/utils';
import { useTranslation } from 'react-i18next';

interface SchedulingBlockedTooltipProps {
  isBlocked: boolean;
  className?: string;
  children: React.ReactNode;
}

// Explains why a scheduling button is disabled. A disabled button ignores pointer events and can't be focused,
// so the tooltip is triggered by a focusable wrapper instead.
export const SchedulingBlockedTooltip = ({ isBlocked, className, children }: SchedulingBlockedTooltipProps) => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'schedulingPaused' });

  if (!isBlocked) return children;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* Focusable so keyboard and screen reader users can reach the explanation of the disabled button */}
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
          <span tabIndex={0} className={cn('rounded-button inline-flex', className)} data-testid='scheduling-blocked-tooltip-trigger'>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent showArrow side='bottom'>
          <p>{t('tooltip')}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
